import { Rating } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Col, Row, Badge, Card } from "react-bootstrap";
import BackArrow from "../../../../components/backArrow";
import { Link } from "react-router-dom";
import { images } from "../../../../constants/index";
import MessageIcon from "@mui/icons-material/Message";
import Button from "react-bootstrap/Button";
import Typography from "@mui/material/Typography";
import ReportIcon from "@mui/icons-material/Report";
import SyncIcon from "@mui/icons-material/Sync";
import { useNavigate } from "react-router-dom";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import SettingsIcon from "@mui/icons-material/Settings";
import BatchPredictionIcon from "@mui/icons-material/BatchPrediction";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import CampaignIcon from "@mui/icons-material/Campaign";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import Salespromotion from "../../../../components/salespromotion_modal";
import GradeIcon from "@mui/icons-material/Grade";
import Qrmodal from "../../../../components/QRmodal/Qrmodal";
import "./style.css";
import { getAsset } from "../../../../helpers/helper";
import Desmodal from "../../../../components/Des_Modal";
import { useGetShopRatingQuery, useGetSubscriptionPurchasesByShopQuery } from "../../../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import noImagePlaceholder from "../../../../assets/images/dummy/no_image_placeholder.png";

import PeopleRatingsModal from "../../../../components/Rating_People";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import RedoIcon from "@mui/icons-material/Redo";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import ShopStarRankLink from "../../../../components/ShopStarRank/ShopStarRankLink";

const RestaurantShopdata = ({
  shopData,
  id,
  suggestdatta,
  setSuggest,
  shopid,
}) => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const { data: purchaseResponse, isLoading: isPurchaseLoading } = useGetSubscriptionPurchasesByShopQuery(id, { skip: !id });
  const isOwner = name?._id && shopData?.userid && (name._id === shopData.userid || name._id === shopData.userid?._id || name._id.toString() === shopData.userid.toString());
  const [show, setShow] = useState(false);
  const [showmodal, setShowmodal] = useState(false);
  const [desshow, setDesshow] = useState(false);
  const closemodal = () => setShowmodal(false);
  const handleClosedes = () => setDesshow(false);
  const handleShowdes = () => setDesshow(true);
  
  const [showmodal_share, setShowmodal_share] = useState(false);
  const [showshare, setShowshare] = useState(false);
  const handleClosemodal_share = () => setShowmodal_share(false);
  const handleCloseshare = () => setShowshare(false);
  const handleShowshare = () => setShowshare(true);
  const [showrating, setShowrating] = useState();

  const [showpeoplerating, setShowpeoplerating] = useState(false);
  const handleClosepeople = () => setShowpeoplerating(false);
  const handleShowpeople = () => setShowpeoplerating(true);
  const { data: ratingData } = useGetShopRatingQuery(shopid, { skip: !shopid });

  useEffect(() => {
    if (ratingData) {
      setShowrating(ratingData?.data?.averageRating);
    }
  }, [ratingData]);
  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        show={showmodal_share}
        handleClosemodal={handleClosemodal_share}
        handleShowshare={handleShowshare}
        shareurl={`/food-buying-profile/${id}`}
        shopTitle={shopData?.shopname}
        shopDesc={shopData?.description}
        shopImage={shopData?.image?.[0]}
      />
      <PeopleRatingsModal
        show={showpeoplerating}
        handleClosepeople={handleClosepeople}
      />

      <Desmodal
        desshow={desshow}
        handleClosedes={handleClosedes}
        des={shopData?.description}
      />
      <Qrmodal show={showmodal} handleClosemodal={closemodal} />
      <Salespromotion show={show} setShow={setShow} shopid={shopid} />

      <Row className="restaurant-shopdata pt-2 pb-2 p-4 pe-2">
        <Row className="restaurant-back-share mb-3 p-0">
          <Col className="text-startps-0">
            <Button variant="link" className="go-back">
              <BackArrow />
            </Button>
          </Col>
          <Col className="text-end pe-0">
            <button
              className="text-white bg-blue  rounded mt-2 pt-1 pb-1 ps-4 pe-4"
              style={{
                backgroundColor: "#0353a4",
                border: "none",
                fontSize: "11px",
              }}
              onClick={() => setShowmodal_share(true)}
            >
              Share <RedoIcon className="share_icon_f" />
            </button>
          </Col>
        </Row>

        {/* Profile Header */}
        <Row className="profile-header restaurant-profile-header align-items-start bg-white p-4 rounded">
          <Col xs={3} md={2} className="restaurant-profile-image text-center">
            <img
              src={shopData?.image ? getAsset(shopData.image) : noImagePlaceholder}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = noImagePlaceholder;
              }}
              alt="Profile"
              className="profile-photo rounded-circle mb-3"
              crossOrigin="anonymous"
            />
          </Col>
          <Col xs={9} md={10} className="restaurant-profile-info">
            <Row className="restaurant-profile-main">
              <Col md={8} className="restaurant-profile-details">
                <h4 className="mb-0">
                  {" "}
                  {shopData?.shopname}
                </h4>
                <ShopStarRankLink
                  shop={shopData}
                  shopId={id}
                  businessType="foodShop"
                />
                <p className="text-muted mb-0">Shop ID: {shopData?.shopid ? btoa(shopData.shopid) : ""}</p>
                <p className="text-muted mb-0">{shopData?.shopaddress}</p>
                <div className="restaurant-description d-flex">
                  <p className="mb-2 font_14">
                    {shopData?.description?.slice(0, 40)}
                  </p>
                  <p className="shop-profile-para mb-0 ">
                    {shopData?.description?.length > 40 && (
                      <span
                        onClick={handleShowdes}
                        className="mb-0 cursor_P font_11 text-dark"
                        style={{ marginTop: "3px" }}
                      >
                        &nbsp;
                        <span style={{ fontWeight: "700" }}>ReadMore...</span>
                      </span>
                    )}
                  </p>
                </div>
                <div className="restaurant-rating d-flex align-items-center mb-2">
                  {showrating && showrating.length > 0 ? (
                    <div className="d-flex">
                      <GradeIcon fontSize="small" />
                      <p className="mb-1 font_small">
                        <Typography
                          component="legend"
                          className="font_small mt-1 "
                        >
                          <b>{showrating}</b>
                        </Typography>
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  &nbsp;&nbsp;
                  <button
                    className="text-white rounded pt-0 pb-0 ps-3 pe-3 border-0 font_11"
                    style={{ backgroundColor: "#0353a4" }}
                    onClick={handleShowpeople}
                  >
                    View Rating
                  </button>
                </div>
              </Col>
              <Col
                md={4}
                className="restaurant-profile-actions text-end d-flex flex-column justify-content-start"
              >
                <div className="restaurant-qr mb-4 text-end">
                  <QrCode2Icon
                    style={{ fontSize: "50px" }}
                    onClick={() => setShowmodal(true)}
                  />
                </div>
                <div className="restaurant-profile-action-buttons">
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() => navigate(`/restaurant-update/${id}`)}
                  >
                    Update Profile
                  </Button>
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() => navigate("/food-business-dashboard")}
                  >
                    Business Dashboard
                  </Button>
                  <Button
                    variant="primary"
                    className="mb-2"
                    onClick={() =>
                      navigate(`/add-consultancy-services-profile/${id}`)
                    }
                  >
                    Add Consultancy Services
                  </Button>
                  {isOwner && (
                    <>
                      {isPurchaseLoading && (
                        <div className="d-flex justify-content-center my-1 mb-2">
                          <span
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                          />
                        </div>
                      )}
                      {!isPurchaseLoading && (
                        <Button
                          variant="primary"
                          onClick={() => {
                            const bt =
                              shopData?.businessType ||
                              shopData?.shopid?.businessType ||
                              "foodShop";
                            const sid =
                              shopData?._id ||
                              shopData?.shopid?._id ||
                              shopid;
                            if (bt) localStorage.setItem("BTtogetMarketer", bt);
                            if (sid) localStorage.setItem("shopid", String(sid));
                            navigate("/hire-marketers");
                          }}
                        >
                          Hire Us For Your Marketing & Ads
                        </Button>
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Tabs */}
        <Row className="tabs-row restaurant-shop-actions bg-white p-3 rounded mt-3 justify-content-start">
          <Col xs="auto" className="me-4">
            <span className="restaurant-shop-action-link" role="button" onClick={() => navigate("/resturant-setting")}>
              <SettingsIcon /> Setting
            </span>
          </Col>

          <Col xs="auto" className="me-4">
            <span
              className="restaurant-shop-action-link"
              role="button"
              onClick={() => navigate(`/Food-Report-section/${id}`)}
            >
              <ReportIcon /> Reports
            </span>
          </Col>

          <Col xs="auto" className="me-4">
            <span
              className="restaurant-shop-action-link"
              role="button"
              onClick={() => {
                setSuggest(1);
                suggestdatta();
              }}
            >
              <EmojiObjectsIcon /> Suggestions
            </span>
          </Col>

          <Col xs="auto" className="me-4">
            <span className="restaurant-shop-action-link" role="button" onClick={() => navigate("/DeliveryForm")}>
              <DeliveryDiningIcon /> Delivery
            </span>
          </Col>

          <Col xs="auto" className="me-4">
            <span className="restaurant-shop-action-link" role="button" onClick={() => navigate(`/promote-shop/${id}`)}>
              <CampaignIcon /> Promote Your Services
            </span>
          </Col>
          <Col xs="auto">
            <span className="restaurant-shop-action-link" role="button" onClick={() => setShow(true)}>
              <LocalOfferIcon /> Add Sales/Special Offer
            </span>
          </Col>
        </Row>
      </Row>
    </>
  );
};

export default RestaurantShopdata;
